export default {
    async downloadFile(url) {
        var path = require('path')
        var name = path.basename(url)
        fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = name
                link.click()
            })
            .catch(console.error)
    },
    parseData(data) {
        const lines = data.trim().split('\n')
        const headers = lines[0].split(';')
        const rows = lines.slice(1).map(line => line.split(';').map(cell => cell.replace(/"/g, '')))
        return { headers, rows }
    },
    createExport(fileName, fileData) {
        const blob = this.generateXLSXFile(fileData)
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${fileName}.xlsx`
        const container = document.getElementById('app')
        container.appendChild(link)
        link.click()
    },
    generateXLSXFile(data) {
        const XLSX = require('xlsx')
        const { headers, rows } = this.parseData(data)
        const worksheetData = [headers, ...rows]
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
        const xlsxBinary = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' })
        const buffer = new ArrayBuffer(xlsxBinary.length)
        const view = new Uint8Array(buffer)
        for (let i = 0; i < xlsxBinary.length; ++i) {
            view[i] = xlsxBinary.charCodeAt(i) & 0xFF
        }
        return new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    }
}
